import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

// ===== SEMIFINAL MAU11: Sunset Warmth — orange-to-purple + glass =====
const Mau11 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const c = {
        accent: '#ffcc44', accentOrange: '#ff6b1a',
        text: '#ffffff', textMuted: 'rgba(255,255,255,0.6)',
        glass: 'rgba(255,255,255,0.1)', glassBorder: 'rgba(255,255,255,0.22)'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div id={id} style={{ width, minHeight: width / 1.3, fontFamily: 'SFUHelveticaCondensedBold', background: `linear-gradient(135deg, #c84b11 0%, #9b2046 35%, #6a0dad 70%, #3a0080 100%)`, position: 'relative', overflow: 'hidden', padding: `${px * 2.5}px` }}>
            <div style={{ position: 'absolute', top: `-${px * 5}px`, left: '30%', width: `${px * 40}px`, height: `${px * 40}px`, borderRadius: '50%', background: 'rgba(255,200,100,0.12)', filter: 'blur(25px)', zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1 }}>
                {/* HEADER */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: `${px * 2.5}px`, background: 'rgba(0,0,0,0.2)', backdropFilter: 'blur(20px)', border: `1px solid rgba(255,255,255,0.2)`, borderRadius: `${px * 1.5}px`, padding: `${px * 1.8}px ${px * 2.5}px` }}>
                    <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', filter: `drop-shadow(0 0 8px rgba(255,200,80,0.5))` }} />
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <h1 style={{ color: c.text, fontSize: `${px * 4.8}px`, textTransform: 'uppercase', margin: 0, letterSpacing: `${px * 0.3}px`, textShadow: `0 2px 10px rgba(0,0,0,0.4)` }}>
                            {t(titleTemplate(dataSchedules[0]?.dataGo))}
                        </h1>
                        <h2 style={{ color: c.accent, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: `${px * 0.5}px 0 0` }}>{dataSeason?.name}</h2>
                        <div style={{ display: 'inline-block', background: `linear-gradient(90deg,${c.accentOrange},${c.accent})`, color: '#1a0800', padding: `${px * 0.35}px ${px * 3}px`, borderRadius: `${px * 3}px`, fontSize: `${px * 2}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px`, letterSpacing: '2px' }}>
                            {t('semifinal')}
                        </div>
                    </div>
                    <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                </div>

                {/* MATCHES */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: `${px * 2}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} c={c} />)}
                </div>

                {/* SPONSORS */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ marginTop: `${px * 3}px`, background: 'rgba(0,0,0,0.2)', backdropFilter: 'blur(20px)', border: `1px solid rgba(255,255,255,0.18)`, borderRadius: `${px}px`, padding: `${px * 1.5}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: `${px * 2}px` }}>
                        {sponsorData?.slice(0, 10)?.map((s, idx) => <Image key={idx} src={s.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain' }} />)}
                    </div>
                )}
                <p style={{ textAlign: 'right', color: 'rgba(255,255,255,0.4)', fontSize: `${px * 1.6}px`, marginTop: `${px * 1.2}px`, letterSpacing: '2px' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}</p>
            </div>
        </div>
    )
}

const Item = React.memo(({ data, px, classCustom, idx, c }) => {
    const { t } = useTranslation()
    const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
    const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']
    let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
    let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''
    let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
    let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name
    let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
    let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

    return (
        <div style={{ width: '100%', background: c.glass, backdropFilter: 'blur(16px)', border: `1px solid ${c.glassBorder}`, borderRadius: `${px * 1.5}px`, padding: `${px * 2}px ${px * 3}px`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: `${px * 14}px`, boxShadow: `0 4px 20px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.15)` }}>
            {/* Home */}
            <div style={{ flex: 1.5, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: `${px * 1.5}px` }}>
                <Image src={data?.homeTeam?.logo} style={{ width: `${px * 9}px`, height: `${px * 9}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid rgba(255,200,80,0.6)`, boxShadow: `0 0 12px rgba(255,150,60,0.4)`, backgroundColor: '#fff', flexShrink: 0 }} />
                <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} isLeft={true} color={c.text} />
            </div>

            {/* Center */}
            <div style={{ flex: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.5}px`, flexShrink: 0 }}>
                <span style={{ color: c.accent, fontSize: `${px * 2}px`, fontWeight: 'bold', letterSpacing: '2px', textTransform: 'uppercase', textShadow: `0 0 8px rgba(255,204,68,0.4)` }}>{t('semifinal')} {idx + 1}</span>
                <span style={{ color: c.textMuted, fontSize: `${px * 1.5}px`, whiteSpace: 'nowrap' }}>{formatDateTime(data?.dateTime, 'time')} — {formatDateTime(data?.dateTime, 'date')}</span>
                {data?.isCompleted ? (
                    <>
                        <div style={{ background: 'rgba(0,0,0,0.4)', border: `2px solid ${c.accent}`, color: c.accent, fontWeight: 900, fontSize: `${px * 5}px`, padding: `${px * 0.5}px ${px * 2.5}px`, borderRadius: `${px * 0.8}px`, letterSpacing: '3px', whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 22}px`, textShadow: `0 0 12px rgba(255,204,68,0.5)` }}>
                            {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                            {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                            {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                            {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                        </div>
                        {data?.hasPenalty && <span style={{ color: '#fc0366', fontSize: `${px * 1.6}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore}</span>}
                    </>
                ) : (
                    <div style={{ background: `linear-gradient(90deg,${c.accentOrange},${c.accent})`, color: '#1a0800', fontWeight: 900, fontSize: `${px * 4.5}px`, padding: `${px * 0.5}px ${px * 2.5}px`, borderRadius: `${px * 3}px`, whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 20}px` }}>
                        {formatDateTime(data?.dateTime, 'time')}
                    </div>
                )}
                {data?.stadium && <span style={{ color: c.textMuted, fontSize: `${px * 1.4}px`, textAlign: 'center', maxWidth: `${px * 20}px`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.stadium}</span>}
            </div>

            {/* Away */}
            <div style={{ flex: 1.5, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: `${px * 1.5}px` }}>
                <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} isLeft={false} color={c.text} />
                <Image src={data?.awayTeam?.logo} style={{ width: `${px * 9}px`, height: `${px * 9}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid rgba(255,255,255,0.35)`, backgroundColor: '#fff', flexShrink: 0 }} />
            </div>
        </div>
    )
}, (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data))

const Name = React.memo(({ name, px, propClass, isLeft, color }) => {
    const reSizeBasedOnWidth = () => {
        const el = document.querySelector(`.${propClass}`)
        const container = document.querySelector(`.contain${propClass}`)
        if (!el || !container) return
        const fontSize = window?.getComputedStyle(el)?.fontSize
        el.style.fontSize = parseFloat(fontSize) - 0.3 * px + 'px'
        if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
    }
    const processInput = () => {
        const el = document.querySelector(`.${propClass}`)
        if (!el) return
        el.innerHTML = name
        el.style.fontSize = px * 3 + 'px'
        reSizeBasedOnWidth()
    }
    React.useEffect(() => { processInput() }, [name])
    return (
        <div className={`contain${propClass}`} style={{ width: '100%', height: `${px * 7}px`, display: 'flex', alignItems: 'center', justifyContent: isLeft ? 'flex-start' : 'flex-end', overflow: 'hidden', padding: `0 ${px}px` }}>
            <h2 className={propClass} style={{ color, textAlign: isLeft ? 'left' : 'right', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2 }} />
        </div>
    )
}, (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name))

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => { if (props.src) getBase64(props.src).then(r => setData(r)) }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau11, areEqual)
